import {
  WarrantsDcaTicketStatus,
  WarrantsDcaType,
  WarrantsTicketType,
} from "@/models/admin/warrantsDcaTicket/warrantsDcaTicket.types"
import {
  FilterRadio,
  FilterType,
  SoDataTableFilters,
} from "@/types/components/SoDataTable"
import { sentenceCase } from "@/helpers/stringHelpers"

// Build a { value: 'Sentence cased label' } map from a PG-enum-mirroring enum.
const optionsFor = (values: string[]): Record<string, string> =>
  values.reduce(
    (options, value) => {
      options[value] = sentenceCase(value)
      return options
    },
    {} as Record<string, string>,
  )

export const statusOptions = optionsFor(Object.values(WarrantsDcaTicketStatus))
export const typeOptions = optionsFor(Object.values(WarrantsTicketType))
export const dcaTypeOptions = optionsFor(Object.values(WarrantsDcaType))

export interface WarrantsDcaTicketsTableFilters extends SoDataTableFilters {
  status: FilterRadio<WarrantsDcaTicketStatus>
  type: FilterRadio<WarrantsTicketType>
  dcaType: FilterRadio<WarrantsDcaType>
}

export const warrantsDcaTicketsTableFilters: WarrantsDcaTicketsTableFilters = {
  status: {
    type: FilterType.RADIO,
    label: "Status",
    value: null,
    options: statusOptions,
    expandable: true,
  },
  type: {
    type: FilterType.RADIO,
    label: "Type",
    value: null,
    options: typeOptions,
    expandable: true,
  },
  dcaType: {
    type: FilterType.RADIO,
    label: "DCA Type",
    value: null,
    options: dcaTypeOptions,
    expandable: true,
  },
}
